export const tariffApiErrors: Record<string, string> = {
  EVSE_ID_NOT_UNIQUE: 'evseIdNotUnique',
};
